var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 14,
    viewBox: "0 0 36 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.094.19a5.522 5.522 0 106.764 3.904.891.891 0 10-1.721.461 3.74 3.74 0 01-2.646 4.58 3.74 3.74 0 11-.44-7.314.892.892 0 00.25-1.766 5.507 5.507 0 00-2.207.134z",
    fill: "#475467"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.803 1.604a.94.94 0 00.345 1.288.94.94 0 001.289-.345.94.94 0 00-.345-1.288.94.94 0 00-.716-.094l-.092.03a.94.94 0 00-.48.41z",
    fill: "#475467"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.925 5.509h1.664V3.682h-1.664V1.62l-1.9.575v1.487h-1.282V5.51h1.282v3.064c0 1.011.265 1.713.795 2.106.54.393 1.463.515 2.77.368V9.324c-.364.02-.668.024-.914.015-.245-.02-.432-.089-.56-.207-.127-.117-.191-.304-.191-.56V5.51z",
    fill: "#475467"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.19 5.509h1.664V3.682H20.19V1.62l-1.9.575v1.487h-1.282V5.51h1.282v3.064c0 1.011.265 1.713.795 2.106.54.393 1.463.515 2.77.368V9.324c-.364.02-.669.024-.914.015-.246-.02-.432-.089-.56-.207-.128-.117-.191-.304-.191-.56V5.51z",
    fill: "#475467"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.209 4.95c.177-.472.466-.826.869-1.061.413-.236.87-.354 1.37-.354v2.121c-.58-.069-1.1.05-1.561.354-.452.304-.678.81-.678 1.517v3.52h-1.9V3.682h1.9V4.95z",
    fill: "#475467"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.552 3.682h-2.033l-1.635 4.95-1.915-4.95h-2.077l3.02 7.13c-.177.5-.417.864-.722 1.09-.294.225-.697.333-1.207.324v1.767c.942.05 1.728-.167 2.356-.648.639-.471 1.15-1.237 1.532-2.298l2.681-7.365z",
    fill: "#475467"
  })));
}
export default SvgLogoText;